/* global showSuccessToast */
/* global showErrorToast */

import React, { useState, useEffect } from "react";
import StatusHistoryModal from "./StatusHistoryModal";
import QualityCallModal from "./QualityCallModal";
import CheckCallModal from "./CheckCallModal";
import ContactHistoryModal from "./ContactHistoryModal";
import { updateTargetItemUsers, updateTargetItemTarget, updateTargetItemDate } from "../../api/api";

const TABS = [
    { id: "status", label: "Stato", icon: "published_with_changes" },
    { id: "check", label: "Check call", icon: "counter_3" },
    { id: "quality", label: "Quality call", icon: "star" },
    { id: "contact", label: "Upselling", icon: "currency_exchange" }
];

const CustomerDetail = ({ label, value }) => (
    <div className="col-6 col-md-4 mb-2">
        <div className="small text-muted">{label}</div>
        <div className="font-weight-bold text-break">{value || "—"}</div>
    </div>
);

const formatPhoneNumber = (value) => {
    const raw = String(value || "").trim();
    const digits = raw.replace(/\D/g, "");
    const countryCode = raw.startsWith("+") && digits.startsWith("39") ? "+39 " : "";
    const localNumber = countryCode ? digits.slice(2) : digits;
    const groups = localNumber.match(/^(\d{3})(\d{3})(\d+)$/);
    const formattedNumber = groups ? `${groups[1]} ${groups[2]} ${groups[3]}` : localNumber;

    return [countryCode.trim(), formattedNumber].filter(Boolean).join(" ");
};

const OrderItemModal = ({ companyID, selectedTargetItem, users, userDetails, onStatusSaved, onQualitySaved, availableTargets = [] }) => {
    const [activeTab, setActiveTab] = useState("status");
    const [soldUserID, setSoldUserID] = useState(selectedTargetItem?.User?.[0]?.id ?? "");
    const [insertedUserID, setInsertedUserID] = useState(selectedTargetItem?.User_coop?.[0]?.id ?? "");
    const [selectedTargetID, setSelectedTargetID] = useState(selectedTargetItem?.Target?.[0]?.id ?? "");
    const [activationDate, setActivationDate] = useState(selectedTargetItem?.date?.substr(0, 10) ?? "");
    const targetID = selectedTargetItem?.id;

    useEffect(() => {
        setActiveTab("status");
    }, [targetID]);

    useEffect(() => {
        setSoldUserID(selectedTargetItem?.User?.[0]?.id ?? "");
        setInsertedUserID(selectedTargetItem?.User_coop?.[0]?.id ?? "");
        setSelectedTargetID(selectedTargetItem?.Target?.[0]?.id ?? "");
        setActivationDate(selectedTargetItem?.date?.substr(0, 10) ?? "");
    }, [targetID, selectedTargetItem?.User?.[0]?.id, selectedTargetItem?.User_coop?.[0]?.id, selectedTargetItem?.date]);

    const handleDateChange = async (field, value) => {
        const prevDate = activationDate;
        setActivationDate(value);
        try {
            await updateTargetItemDate(targetID, { date: value });
            showSuccessToast("Data di attivazione aggiornata con successo");
        } catch (error) {
            setActivationDate(prevDate);
            showErrorToast("Errore durante l'aggiornamento della data di attivazione");
        }
    };

    const handleUserChange = async (field, value) => {
        const prevSold = soldUserID;
        const prevInserted = insertedUserID;
        const newSold = field === "sold" ? value : soldUserID;
        const newInserted = field === "inserted" ? value : insertedUserID;
        if (field === "sold") setSoldUserID(value);
        else setInsertedUserID(value);
        try {
            await updateTargetItemUsers(targetID, { User: newSold, User_coop: newInserted });
            showSuccessToast("Utente aggiornato con successo");
        } catch (error) {
            setSoldUserID(prevSold);
            setInsertedUserID(prevInserted);
            showErrorToast("Errore durante l'aggiornamento dell'utente");
        }
    };

    const handleTargetChange = async event => {
        const nextTargetID = event.target.value;
        setSelectedTargetID(nextTargetID);
        try {
            await updateTargetItemTarget(targetID, { Target: nextTargetID });
            showSuccessToast("Target aggiornato con successo");
        } catch (error) {
            setSelectedTargetID(selectedTargetID);
            showErrorToast("Errore durante l'aggiornamento del target");
        }
    };

    const contact = selectedTargetItem?.Contact?.[0];
    const currentTarget = selectedTargetItem?.Target?.[0] || {};
    const target = availableTargets.find(item => String(item.id) === String(selectedTargetID)) || currentTarget;
    const contactPhone = contact?.phone || "";
    const formattedPhone = formatPhoneNumber(contactPhone);
    const targetDescription = [target.promo, target.tempText].filter(Boolean).join("\n") || "—";

    return (
        <div className="modal fade" id="modal-order-item" tabIndex="-1" role="dialog" aria-labelledby="modal-order-item-title" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modal-order-item-title">
                            Scheda attività
                        </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <section className="card border-0 shadow-sm mb-4 " style={{ backgroundColor: "color-mix(in srgb, Canvas 96%, blue)" }} aria-label="Dati cliente e item">
                            <div className="card-body p-3 p-md-4">
                                <div className="mb-3">
                                    <div>
                                        <div className="small text-muted text-uppercase font-weight-bold mb-1">Cliente</div>
                                        <h5 className="mb-0">
                                            {[contact?.lastName, contact?.firstName].filter(Boolean).join(" ") || "Cliente"}
                                        </h5>
                                        <div className="text-muted">{contact?.companyName || "—"}</div>
                                    </div>
                                </div>
                                <div className="row">
                                    <CustomerDetail label="Cognome" value={contact?.lastName} />
                                    <CustomerDetail label="Nome" value={contact?.firstName} />
                                    <CustomerDetail label="Codice fiscale / P.IVA" value={contact?.fiscalCode?.toUpperCase()} />
                                    <CustomerDetail label="Ragione sociale" value={contact?.companyName} />
                                    <CustomerDetail label="Email" value={contact?.email} />
                                    <CustomerDetail label="WhatsApp" value={contact?.whatsapp} />
                                    <CustomerDetail label="Descrizione cliente" value={contact?.description} />
                                    <CustomerDetail label="Note cliente" value={contact?.note} />
                                    {userDetails?.role <= 0 && (
                                        <CustomerDetail label="ID attività" value={selectedTargetItem?.id} />
                                    )}
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-lg-8 col-12">
                                        <div className="d-flex flex-wrap justify-content-between align-items-center mb-2" style={{ gap: 8 }}>
                                            <div className="small text-muted text-uppercase font-weight-bold">Attività</div>
                                        </div>
                                        {userDetails?.role <= 0 ? (
                                            <select className="form-control form-control-sm font-weight-bold mb-2 w-50" value={selectedTargetID} onChange={handleTargetChange}>
                                                {availableTargets?.map(target => <option key={target.node.id} value={target.node.id}>{target.node.name || "—"}</option>)}
                                            </select>
                                        ) : (
                                            <h6 className="font-weight-bold mb-2">{target.name || "—"}</h6>
                                        )}
                                        <div className="text-break" style={{ whiteSpace: "pre-line" }}>{targetDescription}</div>
                                        <div className="d-flex flex-wrap mt-2" style={{ gap: 8 }}>
                                            <span className="badge badge-light">{target.TargetType?.map(type => type.name).filter(Boolean).join(", ") || "Tipo: —"}</span>
                                            <span className="badge badge-light">Punti rewards: {target.fee ?? "—"}</span>
                                            <span className="badge badge-light">Punti soglia: {target.points ?? "—"}</span>
                                        </div>
                                        <div className="row mt-3">
                                            {userDetails?.role <= 0 ? (
                                                <>
                                                    <div className="col-6 col-md-4 mb-2">
                                                        <label className="small text-muted" htmlFor="order-item-sold-user">Venduto</label>
                                                        <select id="order-item-sold-user" className="form-control form-control-sm" value={soldUserID} onChange={event => handleUserChange("sold", event.target.value)}>
                                                            {users?.map(user => <option key={user.node.id} value={user.node.id}>{user.node.username}</option>)}
                                                        </select>
                                                    </div>
                                                    <div className="col-6 col-md-4 mb-2">
                                                        <label className="small text-muted" htmlFor="order-item-inserted-user">Inserito</label>
                                                        <select id="order-item-inserted-user" className="form-control form-control-sm" value={insertedUserID} onChange={event => handleUserChange("inserted", event.target.value)}>
                                                            {users?.map(user => <option key={user.node.id} value={user.node.id}>{user.node.username}</option>)}
                                                        </select>
                                                    </div>
                                                    <div className="col-6 col-md-4 mb-2">
                                                        <label className="small text-muted" htmlFor="order-item-activation-date">Data attivazione</label>
                                                        <input id="order-item-activation-date" type="date" className="form-control form-control-sm" value={activationDate} onChange={event => handleDateChange("date", event.target.value)} />
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <CustomerDetail label="Venduto" value={selectedTargetItem?.User?.[0]?.username} />
                                                    <CustomerDetail label="Inserito" value={selectedTargetItem?.User_coop?.[0]?.username} />
                                                    <CustomerDetail label="Data attivazione" value={selectedTargetItem?.date?.substr(0, 10).split("-").reverse().join("/")} />
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-4 d-flex align-items-end col-12 mt-3">
                                        <div className="d-flex justify-content-center justify-content-lg-end w-100">
                                            <a
                                                href={contactPhone ? `tel:${contactPhone}` : undefined}
                                                className={`btn d-inline-flex align-items-center px-3 py-4 ${contactPhone ? "btn-primary" : "btn-light text-muted"}`}
                                                style={{ fontSize: "1.15rem", fontWeight: 700, textDecoration: "none" }}
                                                aria-label={contactPhone ? `Chiama ${formattedPhone}` : "Telefono non disponibile"}
                                            >
                                                <span className="material-symbols-outlined mr-2" aria-hidden="true">call</span>
                                                {formattedPhone || "Telefono non disponibile"}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            {TABS.map(tab => (
                                <li className="nav-item" key={tab.id} role="presentation">
                                    <button
                                        type="button"
                                        role="tab"
                                        aria-selected={activeTab === tab.id}
                                        className={`nav-link d-flex align-items-center${activeTab === tab.id ? " active" : ""}`}
                                        onClick={() => setActiveTab(tab.id)}
                                    >
                                        <span className="material-symbols-outlined mr-1" style={{ fontSize: "18px" }} aria-hidden="true">{tab.icon}</span>
                                        {tab.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                        {selectedTargetItem && (
                            <React.Fragment>
                                <div style={{ display: activeTab === "status" ? "block" : "none" }}>
                                    <StatusHistoryModal companyID={companyID} selectedTargetItem={selectedTargetItem} onSaved={onStatusSaved} users={users} />
                                </div>
                                <div style={{ display: activeTab === "check" ? "block" : "none" }}>
                                    <CheckCallModal companyID={companyID} selectedTargetItem={selectedTargetItem} onSaved={onQualitySaved} />
                                </div>
                                <div style={{ display: activeTab === "quality" ? "block" : "none" }}>
                                    <QualityCallModal companyID={companyID} selectedTargetItem={selectedTargetItem} onSaved={onQualitySaved} selectedContact={contact} />
                                </div>
                                <div style={{ display: activeTab === "contact" ? "block" : "none" }}>
                                    <ContactHistoryModal selectedContact={contact} users={users} />
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderItemModal;
